var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['container__tag', _vm.className],on:{"click":function($event){return _vm.$emit('click', _vm.label)}}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }